import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { PopupService } from '../../shared/modal/popup.service';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { InventoryContext } from '../../inventory-manager/inventory.context';
import { HttpResponse } from '@angular/common/http';
import { ModalConfirmComponent } from '../../shared/modal/modal-confirm.component';
import { TranslateService } from '@ngx-translate/core';
import { AlertService } from '../../shared/alert/alert.service';
import { JhiEventManager, JhiLanguageService } from '../../shared/core-utils';
import { LotService } from '../../shared/inventory/service/lot.service';
import { TransactionService } from '../../shared/inventory/service/transaction.service';
import { SubscriptionsManager } from '../../shared/util/subscriptions-manager';

@Component({
    selector: 'jhi-lot-balance-adjustment-dialog',
    templateUrl: './lot-balance-adjustment-dialog.component.html'
})
export class LotBalanceAdjustmentDialogComponent implements OnInit, OnDestroy {
    searchResultDbId: string;
    notes: any;
    balance: any;
    subscriptionsManager = new SubscriptionsManager();

    constructor(private jhiLanguageService: JhiLanguageService,
                private inventoryContext: InventoryContext,
                private activatedRoute: ActivatedRoute,
                private alertService: AlertService,
                public activeModal: NgbActiveModal,
                private transactionService: TransactionService,
                private lotService: LotService,
                private eventManager: JhiEventManager,
                private translateService: TranslateService,
                private modalService: NgbModal) {
        this.subscriptionsManager.add = this.activatedRoute.queryParams.subscribe((params) => {
            this.searchResultDbId = params.searchResultDbId;
        });

    }

    ngOnDestroy(): void {
        this.subscriptionsManager.unsubscribeAll();
    }

    ngOnInit(): void {
    }

    clear() {
        this.activeModal.dismiss('cancel');
    }

    save() {
        const lotBalanceAdjustmentRequest = {
            selectedLots: { searchRequest: null, itemIds: null },
            notes: this.notes,
            balance: this.balance
        };

        if (this.searchResultDbId) {
            lotBalanceAdjustmentRequest.selectedLots.searchRequest = this.searchResultDbId;
        } else {
            lotBalanceAdjustmentRequest.selectedLots.itemIds = this.inventoryContext.itemIds;
        }

        this.subscriptionsManager.add = this.lotService.getSearchMetaData(lotBalanceAdjustmentRequest.selectedLots).subscribe(
            (res: HttpResponse<any>) => {
                if (res.body.lotsCountByUnitName.NULL_VALUES) {
                    this.alertService.error('inventoryManagerApp.lot.messages.error.empty.units', {
                        param: res.body.lotsCountByUnitName.NULL_VALUES
                    });
                } else {
                    if (Object.keys(res.body.lotsCountByUnitName).length > 1) {
                        const confirmModalRef = this.modalService.open(ModalConfirmComponent as Component);
                        confirmModalRef.componentInstance.title = this.translateService.instant('inventoryManagerApp.lot.adjustment.multiple.units.confirmation.title');
                        confirmModalRef.componentInstance.message = this.translateService.instant('inventoryManagerApp.lot.adjustment.multiple.units.confirmation.message');
                        confirmModalRef.result.then(() => {
                            this.subscriptionsManager.add = this.transactionService.createAdjustments(lotBalanceAdjustmentRequest)
                                .subscribe(
                                    (response: HttpResponse<any>) =>
                                        this.onSaveSuccess('inventoryManagerApp.lot.adjustment.success'));
                            this.activeModal.close();
                        }, () => this.activeModal.dismiss());
                        return;
                    }

                    this.subscriptionsManager.add = this.transactionService.createAdjustments(lotBalanceAdjustmentRequest)
                        .subscribe(
                            (response: HttpResponse<any>) =>
                                this.onSaveSuccess('inventoryManagerApp.lot.adjustment.success'));

                }

            }
        );

    }

    private onSaveSuccess(message: any) {
        this.alertService.success(message);
        this.eventManager.broadcast({ name: 'columnFiltersChanged', content: 'OK' });
        this.activeModal.close('saved');
    }

}

@Component({
    selector: 'jhi-lot-balance-adjustment-popup',
    template: ''
})
export class LotBalanceAdjustmentPopupComponent implements OnInit, OnDestroy {

    routeSub: any;

    constructor(
        private route: ActivatedRoute,
        private popupService: PopupService
    ) {
    }

    ngOnInit() {
        this.routeSub = this.route.params.subscribe(() => {
            this.popupService.open(LotBalanceAdjustmentDialogComponent as Component, { size: 'lg', backdrop: 'static' });
        });
    }

    ngOnDestroy() {
        this.routeSub.unsubscribe();
    }
}
